module.exports = __webpack_public_path__ + "static/img/1844_phase_function_Paper_Points.06513c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1844_phase_function_Paper_Points.png
// module id = yNBJ
// module chunks = 0